<template>

    <input-child
            v-bind="getInputProps({})"

            v-model="inputValue"

            ref="input"
    >
        <template #input="{ name, id, inputClass, placeholder, required, readonly, disabled, onClick, onFocus, onBlur, value }">
            <select
                    :name="name || false"
                    :id="id"
                    :class="['form-control d-flex flex-grow-1 w-100 border-0 px-4 py-0 mr-3', inputClass]"

                    :placeholder="placeholder"

                    :required="required"

                    :readonly="readonly"
                    :disabled="disabled"

                    @click="onClick"
                    @focus="onFocus"
                    @blur="onBlur"

                    @change="onSelect"

                    v-on:input="$emit('input', $event.target.value)"

                    :value="value"

                    v-model="inputValue"

                    ref="select"
            >
                <slot name="options" :selectList="selectList" :inputValue="inputValue">
                    <template v-for="item in selectList">
                        <option :value="item.value" :selected="item.value === inputValue">
                            {{ item.text }}
                        </option>
                    </template>
                </slot>
            </select>
        </template>


        <template #beforeInput>
            <slot name="beforeInput"></slot>
        </template>
        <template #afterInput>
            <div class="position-absolute right top bottom pointer-events-none mr-1">
                <i class="fa fa-chevron-down"></i>
            </div>
            <slot name="afterInput"></slot>
        </template>


        <template #hidden>
            <slot
                    name="hidden"
                    v-bind="{ selectList }"
            >
            </slot>
        </template>
        <template #next>
            <slot
                    name="next"
                    v-bind="{ selectList, inputValue }"
            >
            </slot>
        </template>
        <template #prev>
            <slot
                    name="prev"
                    v-bind="{ selectList, inputValue }"
            >
            </slot>
        </template>
    </input-child>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinInput from './mixinInput';

    import Input from './Input'

    const {props} = Input;

    export default {
        mixins: [mixinCommon, mixinInput],

        components: {
            'input-child': Input
        },
        props: {
            ...props,

            onSelect: {
                type: Function,
                default: () => {
                }
            },
            selectListDefault: {
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                selectList: this.selectListDefault
            };
        },
        computed: {},
        watch: {
            selectListDefault(inputValue) {
                this.selectList = inputValue;
            },
            inputValue(inputValue) {
                this.$emit('input', inputValue);
                this.$root.$emit(this.name  + '-change-value', inputValue);
            },
            defaultAutocompleteList: {
                handler(defaultAutocompleteList) {
                    this.autocompleteList = defaultAutocompleteList;
                },
                deep: true
            },
            selected: {
                handler(item = null) {
                    const {text = ''} = item || {};
                    this.inputValue = text;
                    this.onSelect(item);
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            onIconClick() {
                $(this.$refs.select).click();
            },

            onSelectItem(item, evt) {
                evt.preventDefault();
                this.selectItem(item);
                this.dropdownShow = false;
            },

            selectItem(item) {
                this.selected = item;
                this.inputValue = item ? item.text : '';
            },

            matchToAutocomplete(pos = null) {
                if (!!this.autocompleteList.length) {
                    return false;
                }
                if (pos >= 0 && this.autocompleteList.length < pos + 1) {
                    return false;
                }

                const list = this.autocompleteList[pos] ? [this.autocompleteList[pos]] : this.autocompleteList;
                for (let item of list) {
                    if (this.inputValue.toLowerCase().trim() === item.text.toLowerCase().trim()) {
                        return item;
                    }
                }

                return false;
            },
            matchToSelected() {
                if (!this.selected) {
                    return false;
                }

                return this.inputValue.toLowerCase().trim() === this.selected.text.toLowerCase().trim();
            },

            async fetchAutocomplete() {
                if (!!+this.disableAjax) {
                    return;
                }

                if (typeof this.autocompleteHandler === 'function') {
                    return await this.autocompleteHandler();
                }

                await this.callAjax({query: this.inputValue});

                if (this.isBlur()) {
                    return this.resetAutocomplete();
                }

                return this.autocompleteList = this.responseData || [];
            },

            async onInputWrite(evt) {
                if (this.timer) clearTimeout(this.timer);

                switch (evt.which) {
                    case 13 :
                        evt.preventDefault();
                        await this.fetchAutocomplete();
                        return this.blur();
                        break;
                    default :
                        break;
                }

                this.timer = setTimeout(async () => {
                    this.dropdownShow = this.isFocus();

                    await this.fetchAutocomplete();
                }, 400);
            },

            onInputFocus(evt) {
                this.dropdownShow = this.isFocus();
            },
            onInputBlur(evt) {
                this.dropdownShow = false;

                if (!this.matchToSelected()) {
                    const itemMatch = this.matchToAutocomplete();

                    if (this.strictSelection) {
                        this.selectItem(itemMatch || this.firstAutocomplete || this.selected);
                    } else {
                        this.selectItem(itemMatch || {text: this.inputValue});
                    }
                }

                this.resetAutocomplete();
            },

            resetAutocomplete() {
                return this.autocompleteList = this.defaultAutocompleteList || [];
            },


            getInputProps(overrideProps = {}) {
                return this.getComponentProps(Input, overrideProps);
            }
        }
    };
</script>
